import React from "react";
import { IoCheckmarkSharp } from "react-icons/io5";
import "./EAChoiceChip.scss";

interface IProps {
  label: string;
  isSelected: boolean;
  size?: "small" | "medium";
  onClick: () => void;
  fullWidth?: boolean;
  showSelectedIcon?: boolean;
}

const EAChoiceChip: React.FC<IProps> = ({
  label,
  isSelected,
  size = "medium",
  onClick,
  fullWidth = false,
  showSelectedIcon = true,
}) => {
  return (
    <div
      className={`choice-chip choice-chip--${size} ${isSelected ? "choice-chip--selected" : ""} ${
        fullWidth ? "choice-chip--fullWidth" : ""
      }`}
      onClick={onClick}
    >
      {isSelected && showSelectedIcon && (
        <span className="choice-chip__icon">
          <IoCheckmarkSharp />
        </span>
      )}
      <h5 className="choice-chip__label">{label}</h5>
    </div>
  );
};

export default EAChoiceChip;
